import { Controller, useFormContext } from 'react-hook-form';
import { IGroupingStatuses } from '../../../models/tableConfig';
import { useBankPanelStore } from '../../../store/bankPanelStore';
import {
  isLoanQuoteStatusEditable,
  selectableLoanQuoteStatusOptions,
} from '../QuoteDataForm/utils/loanQuoteStatusUtils';
import { LoanQuoteDataFormValues } from '../QuoteDataForm/QuoteDataFormSchema';
import { loan_quote } from '@axo/shared/data-access/types';
import styles from '../BankPanel.module.css';
import { classNames } from '../../../utils/classNames';
import { StatusTag } from '../../StatusTag';
import { Tooltip } from '@blueprintjs/core';

interface LoanQuoteStatusProps {
  applicationID: string;
  item: loan_quote.BankQuote;
  groupedStatuses: IGroupingStatuses;
}

export const LoanQuoteStatus: React.FC<LoanQuoteStatusProps> = ({
  applicationID,
  item,
  groupedStatuses,
}) => {
  const { isQuoteBeingEdited } = useBankPanelStore(applicationID);
  const { setValue: setLoanQuoteFormValue } =
    useFormContext<LoanQuoteDataFormValues>();

  // Only render first cell in a group
  if (
    groupedStatuses?.['LoanQuoteID']?.isInGroup &&
    !groupedStatuses?.['LoanQuoteID']?.isFirstInGroup
  ) {
    return (
      <div
        className={classNames(
          styles.tagContainer,
          styles.grouped,
          groupedStatuses?.['LoanQuoteID']?.isLastInGroup && styles.lastInGroup,
        )}
      />
    );
  }

  if (isQuoteBeingEdited(item.ID) && isLoanQuoteStatusEditable(item.Status)) {
    return (
      <div
        className={classNames(
          groupedStatuses?.['LoanQuoteID']?.isInGroup && styles.grouped,
          groupedStatuses?.['LoanQuoteID']?.isFirstInGroup &&
            styles.firstInGroup,
        )}
      >
        <Controller
          name={`${item.ID}.Status`}
          render={({ field }) => (
            <select
              value={field.value}
              onChange={(e) =>
                setLoanQuoteFormValue(`${item.ID}.Status`, e.target.value)
              }
            >
              <option value={undefined}>-</option>
              {selectableLoanQuoteStatusOptions(item.Status)?.map(
                (quoteStatus) => (
                  <option key={quoteStatus} value={quoteStatus}>
                    {quoteStatus}
                  </option>
                ),
              )}
            </select>
          )}
        />
      </div>
    );
  }

  const loanQuoteStatus = item.Status;

  return (
    <div
      className={classNames(
        styles.tagContainer,
        groupedStatuses?.['LoanQuoteID']?.isInGroup && styles.grouped,
        groupedStatuses?.['LoanQuoteID']?.isFirstInGroup && styles.firstInGroup,
      )}
    >
      {!loanQuoteStatus && '-'}
      {loanQuoteStatus && (
        <Tooltip
          content={
            <>
              <span>
                <b>{item.Status}</b>
              </span>
              {item.LenderStatus && (
                <>
                  <br />
                  <span>{item?.LenderStatus}</span>
                </>
              )}
            </>
          }
          placement="bottom"
          renderTarget={({ isOpen: _, ...targetProps }) => (
            <span {...targetProps}>
              <StatusTag status={item.Status}>{item.Status}</StatusTag>
            </span>
          )}
        />
      )}
    </div>
  );
};
